import { Emptyable } from './emptyable';
import { normalize } from './string';

export function isClean(email: Emptyable<string>): boolean {
    return (
        typeof email !== 'string' || email.trim() === '' || normalize(email.toLowerCase()) === email
    );
}
